export function InputNumberMaxLengthDirective() {
  return function (scope, element, attrs) {
    element.bind('input', function () {
      let inputLength = element.val().length;
      let inputMaxLength = attrs.inputNumberMaxLength;

      if (inputLength && inputLength > inputMaxLength) {
        element.val(element.val().slice(0, inputMaxLength));
      }
    });
  };
}
